import React from 'react';

import { Box, Button, Dialog, DialogActions, DialogContent, IconButton, Snackbar, TextField, Tooltip} from '@mui/material';
import { makeStyles } from '@mui/styles';

import { Cancel, Check, Edit, FindInPage } from '@mui/icons-material';

import axios from '../../../../common/AxiosConfig';

import { AppContext } from '../../../../../RoutesWithAuth';

import { useContext } from 'react';

import { Alert } from '@mui/lab';

import { useState } from 'react';

import CustomDialog from '../../Dialog';

import { LoadingIndicator } from '../../reports/reconcilationreport/MuiStyled';

import { RESPONSE_ACTION_MAPPING, TOYOTA_CONNECTED_NAMES,TMNA_SERVICENOW } from './constants';

import { DialogTitle } from '../../reports/ReportCommonPopup';

import { useRef } from 'react';

import { standardButtonStyle } from '../buttonStyles';

import PermissionButton from '../../PermissionButton';

import { HOME_PERMISSIONS } from '../../../../common/RolePermissions';



const generateJiraBaseLink = (name, ticket_id) => {

    if (name === "Cerence") {
        return `https://tgt.assist.com/portal/incidents/${ticket_id}`;
    } else if (TOYOTA_CONNECTED_NAMES.includes(name)) {
        return `https://toyotaconnected.atlassian.net/browse/${ticket_id}`
    } else if (TMNA_SERVICENOW.includes(name)) {
        return `https://tmna.service-now.com/sc_req_item_list.do?sysparm_first_row=1&sysparm_query=GOTOnumber%3d${ticket_id}`
    }
    return null;
}



const useStyles = makeStyles(() => ({
    tableWrapper: {
        height: '100%',
        overflow: 'auto',
        border: '1px solid #e2e8f0',
        borderRadius: '8px',
        '& table': {
            width: '100%',
            borderCollapse: 'collapse',
            fontSize: '0.85rem',
        },
        '& thead': {
            background: '#778899',
            position: 'sticky',
            top: 0,
            zIndex: 10,
        },
        '& th': {
            padding: '12px 16px',
            textAlign: 'left',
            color: '#fff',
            fontWeight: 600,
            fontSize: '0.85rem',
            borderRight: '1px solid rgba(255,255,255,0.1)',
            letterSpacing: '0.3px',
            position: 'sticky',
            top: 0,
            background: '#778899',
            userSelect: 'none',
            zIndex: 9,
            '&:last-child': {
                borderRight: 'none',
            },
        },
        '& .resize-handle': {
            position: 'absolute',
            right: 0,
            top: 0,
            bottom: 0,
            width: '8px',
            cursor: 'col-resize',
            userSelect: 'none',
            zIndex: 1,
            '&:hover': {
                background: 'rgba(255,255,255,0.2)',
            },
        },
        '& tbody tr': {
            background: '#fff',
            borderBottom: '1px solid #edf2f7',
            transition: 'background-color 0.2s ease',
            '&:nth-of-type(odd)': {
                background: '#f8fafc',
            },
            '&:hover': {
                background: '#f0f7ff',
            },
            '&.isInactive-row-cust-cls': {
                background: '#fee2e2 !important',
                color: '#dc3545',
                '&:hover': {
                    background: '#fecaca !important',
                },
            },
        },
        '& td': {
            padding: '12px 16px',
            borderRight: '1px solid #edf2f7',
            color: '#334155',
            fontSize: '0.85rem',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            '&:last-child': {
                borderRight: 'none',
            },
        },
    },
    dialog: {
        fontSize: '0.85rem',
        '& .MuiDialogTitle-root': {
            padding: '10px 16px',
            background: 'linear-gradient(135deg, #1e3a5f 0%, #267db7 125%, #3b9edd 100%)',
            color: 'white',
            fontWeight: 600,
            fontSize: '0.95rem',
            letterSpacing: '0.3px',
        },
        '& .MuiDialogContent-root': {
            padding: '20px 24px',
        },
        '& .isInvalidText': {
            marginTop: '8px',
            textAlign: 'center',
            color: '#dc2626',
            fontSize: '0.82rem',
        },
        '& .MuiDialogActions-root': {
            justifyContent: 'flex-end',
            padding: '12px 24px',
            gap: '10px',
            '& .MuiButton-root': {
                padding: '6px 24px',
                fontSize: '0.8rem',
                textTransform: 'none',
                fontWeight: 500,
                borderRadius: '4px',
            },
            '& .MuiButton-root:first-child': {
                background: 'linear-gradient(180deg, #ef4444 0%, #dc2626 54%, #991b1b 125%)',
                color: 'white',
                '&:hover': {
                    background: 'linear-gradient(180deg, #dc2626 0%, #b91c1c 54%, #7f1d1d 125%)',
                },
            },
            '& .MuiButton-root:last-child': {
                background: 'linear-gradient(180deg, #3b9edd 0%, #267db7 54%, #1e3a5f 125%)',
                color: 'white',
                '&:hover': {
                    background: 'linear-gradient(180deg, #2a8acc 0%, #1e6aa6 54%, #162d4e 125%)',
                },
            },
        }
    },
}));

const List = ({
    data,
    requestDetails, handleViewResponseDownstream,
    reloadInformation
}) => {

    const context = useContext(AppContext)
    const authToken = context.authToken.get;
    const isAdmin = context.isAdmin.get;
    const classes = useStyles();
    const ticketIdRefInput = useRef();


    const [message, setMessage] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    // displayHubStatusPopup state is used to store popup visibility state
    // true represents Popup to be visible ,false - represents popup should be hidden
    const [displayDialog, setDisplayDialog] = useState(false);

    // hubStatusData state is used to store hub status API response.
    // null represents Loading , [] - represents Empty response
    const [hubStatusData, setHubStatusData] = useState(null);

    const [createStatusData, setCreateStatusData] = useState(null);
    const [createInvalidMsg, setCreateInvalidMsg] = useState(null);
    
    // State for column widths
    const [columnWidths, setColumnWidths] = useState({});
    const [editingTicket, setEditingTicket] = useState(null);
    const [editingRequestAutomated, setEditingRequestAutomated] = useState(null);

    const isSystemTicketClosed = (row) => {
        const responseAction = row?.response_action;
        const isErrorStatus = responseAction === 'error' || responseAction === 'unable_to_retrieve';
        // Closed means response has been received and status is not error.
        return row?.response_is_open === false && !isErrorStatus;
    };

    const canEditJiraTicket = (row) => {
        const isJiraIntegration = row?.integration_pattern === 'Jira Push';
        return Boolean(isAdmin && isJiraIntegration && !isSystemTicketClosed(row));
    };

    const handleEditJiraTicket = (row) => {
        setEditingTicket({
            rowId: row.id,
            appId: row.id,
            currentValue: row.system_generated_ticket_id || ''
        });
    };

    const handleCancelEditJiraTicket = () => {
        setEditingTicket(null);
    };

    const handleSaveJiraTicket = () => {
        const updatedTicketId = String(editingTicket?.currentValue || '').trim();
        if (!updatedTicketId) {
            setMessage({
                severity: 'error',
                text: 'JIRA ID is mandatory'
            });
            return;
        }

        setIsLoading(true);
        axios.post('app_tickets/mark_created', {
            dsar_id: requestDetails.dsar_id,
            app_id: editingTicket.appId,
            system_generated_ticket_id: updatedTicketId,
        }, {
            headers: {
                Authorization: authToken
            }
        }).then(() => {
            setIsLoading(false);
            setEditingTicket(null);
            setMessage({
                severity: 'success',
                text: 'JIRA ID updated successfully'
            });
            reloadInformation();
        }).catch(() => {
            setIsLoading(false);
            setMessage({
                severity: 'error',
                text: 'Error updating JIRA ID'
            });
        });
    };

    const handleEditRequestAutomated = (row) => {
        setEditingRequestAutomated({
            rowId: row.id,
            appId: row.id,
            currentValue: row.is_request_automated || 'No'
        });
    };

    const handleCancelEditRequestAutomated = () => {
        setEditingRequestAutomated(null);
    };

    const handleSaveRequestAutomated = () => {
        setIsLoading(true);
        axios.put('app_tickets/automation', {
            dsar_id: requestDetails.dsar_id,
            app_id: editingRequestAutomated.appId,
            is_request_automated: editingRequestAutomated.currentValue === 'Yes'? true : false,
        }, {
            headers: {
                Authorization: authToken
            }
        }).then(() => {
            setIsLoading(false);
            setEditingRequestAutomated(null);
            setMessage({
                severity: 'success',
                text: 'Request Automated status updated successfully'
            });
            reloadInformation();
        }).catch(() => {
            setIsLoading(false);
            setMessage({
                severity: 'error',
                text: 'Error updating Request Automated status'
            });
        });
    };

    const handleCreate = (rowInfo) => {
        setCreateStatusData(rowInfo);
    }

    const handleCreateStatusDialogClose = () => {
        setCreateStatusData(null);
        setCreateInvalidMsg(null);
    }
    const handleCreateStatusDialogSubmit = () => {
        let selectedValue = ticketIdRefInput.current.querySelector("input").value;
        if (!selectedValue) {
            setCreateInvalidMsg("Ticket ID is mandatory");
        } else {
            setCreateInvalidMsg(null);
            setIsLoading(true);
            setCreateStatusData(null);
            axios.post('app_tickets/mark_created', {
                dsar_id: requestDetails.dsar_id,
                app_id: createStatusData.id,
                system_generated_ticket_id: selectedValue,
            }, {
                headers: {
                    Authorization: authToken
                }
            }).then(res => {

                setIsLoading(false);
                reloadInformation();

            }).catch(() => {
                setIsLoading(false);
            })
        }
    }

    const handleReCreate = (rowInfo) => {
        setIsLoading(true)
        axios.post('/downstream/resend_message', {
            dsar_id: requestDetails.dsar_id,
            app_name: rowInfo["name"],
        }, {
            headers: {
                Authorization: authToken
            }
        }).then(res => {
            setIsLoading(false)
            setMessage({
                severity: "success",
                text: res.data.message
            })
        }).catch(err => {
            setIsLoading(false)
            if (err.response.data.message) {
                setMessage({
                    severity: "error",
                    text: err.response.data.message
                })
            }
        })
    }
    /**
     * triggerHubStatus Function will be called when user clicks on the Hub Icon.
     */
    const triggerHubStatus = () => {
        // Display the Hub Status Dialog
        setDisplayDialog(true);
        // Mark the loading State null represents loading is true
        setHubStatusData(null);
        axios.get(`tc/tc_hub_status?dsar_id=${requestDetails.dsar_id}`, {
            headers: {
                Authorization: authToken
            }
        }).then(res => {
            let tc_hub_response = res?.data || [];
            // when there is no data available
            if (res.status === 204) {
                tc_hub_response = [];
            }
            // Sorting the Response based on the Product Name
            tc_hub_response = tc_hub_response.sort((a, b) => {
                if (a.product < b.product) {
                    return -1;
                } else if (a.product > b.product) {
                    return 1;
                }
                return 0;
            });
            setHubStatusData(tc_hub_response);
        }).catch(err => {
            console.log(err)
            setHubStatusData([]);
        })

    }

    const columns = [{
        name: "Application Name",
        mapping: "display",
        flex: 1,
        renderCell: (params) => {

            const app_name = params.row["name"];
            if (app_name === "TC") {
                return (
                    <>
                        {params.row["display"]}
                        <Tooltip title={"View TC Sub System Status"} >
                            <Button
                                variant="text"
                                size="small"
                                style={{
                                    marginLeft: "10px",
                                    minWidth: 'auto',
                                    padding: '4px 8px',
                                }}
                                onClick={triggerHubStatus}
                            >
                                <img src="/TCHubStatus.png" height="20" alt="TCHubStatus" />
                            </Button>
                        </Tooltip>
                    </>
                )
            }
            return params.row["display"]

        }
    },
    {
        name: "Response Action",
        mapping: "response_action",
        width: 160,
        renderCell: (params) => {

            const expected_attachments = params.row["expected_attachments"];
            const existing_attachments = params.row["actual_attachments"];
            const response_action = params.row["response_action"];
            return (
                <>
                    {RESPONSE_ACTION_MAPPING[response_action]}
                    {(expected_attachments - existing_attachments > 0) && (
                        <Tooltip title={`Pending ${expected_attachments - existing_attachments} attachment(s)`}>
                            <Box marginLeft={"10px"}>
                                <img src="/yellow_missing.png" width="20" alt="pending" />
                            </Box>
                        </Tooltip>
                    )}
                </>
            )
        }
    },
    {
        name: "Ticket Created On",
        mapping: "created_date_utc",
        displayTootip: ["created_date_local"],
        width: 160
    }, {
        name: "Response Received On ",
        mapping: "response_created_date_utc",
        displayTootip: ["response_created_date_local"],
    }, {
        name: "Request Automated",
        mapping: "is_request_automated",
        renderCell: (params) => {
            const isEditing = editingRequestAutomated?.rowId === params.row.id;
            const currentValue = params.row["is_request_automated"];

            if (isEditing) {
                return (
                    <Box display="flex" alignItems="center" gap="6px">
                        <select
                            value={editingRequestAutomated.currentValue}
                            onChange={(e) => {
                                setEditingRequestAutomated((prev) => ({
                                    ...prev,
                                    currentValue: e.target.value
                                }));
                            }}
                            style={{
                                padding: '4px 8px',
                                fontSize: '0.8rem',
                                borderRadius: '4px',
                                border: '1px solid #ccc',
                                fontFamily: 'inherit'
                            }}
                        >
                            <option value="Yes">Yes</option>
                            <option value="No">No</option>
                        </select>
                        <Tooltip title="Save">
                            <span>
                                <IconButton size="small" onClick={handleSaveRequestAutomated}>
                                    <Check fontSize="small" />
                                </IconButton>
                            </span>
                        </Tooltip>
                        <Tooltip title="Cancel">
                            <span>
                                <IconButton size="small" onClick={handleCancelEditRequestAutomated}>
                                    <Cancel fontSize="small" />
                                </IconButton>
                            </span>
                        </Tooltip>
                    </Box>
                );
            }

            return (
                <Box display="flex" alignItems="center" gap="4px">
                    <span>{currentValue}</span>
                    <Tooltip title="Edit">
                        <span>
                            <PermissionButton
                                iconOnly
                                permission={HOME_PERMISSIONS.REQUEST_AUTOMATED}
                                size="small"
                                aria-label="edit request automated"
                                onClick={() => handleEditRequestAutomated(params.row)}
                            >
                                <Edit fontSize="small" />
                            </PermissionButton>
                        </span>
                    </Tooltip>
                </Box>
            );
        }
    }, {
        name: "JIRA ID",
        mapping: "system_generated_ticket_id",
        renderCell: (params) => {
            const name = params.row["name"];
            const jiraId = params.row["system_generated_ticket_id"];
            const isEditing = editingTicket?.rowId === params.row.id;
            const isEditable = canEditJiraTicket(params.row);

            if (isEditing) {
                return (
                    <Box display="flex" alignItems="center" gap="6px">
                        <TextField
                            size="small"
                            value={editingTicket.currentValue}
                            onChange={(e) => {
                                setEditingTicket((prev) => ({
                                    ...prev,
                                    currentValue: e.target.value
                                }));
                            }}
                            placeholder="JIRA ID"
                            sx={{
                                minWidth: '140px',
                                '& .MuiInputBase-input': {
                                    fontSize: '0.8rem',
                                    padding: '4px 8px'
                                }
                            }}
                        />
                        <Tooltip title="Save">
                            <span>
                                <IconButton size="small" onClick={handleSaveJiraTicket}>
                                    <Check fontSize="small" />
                                </IconButton>
                            </span>
                        </Tooltip>
                        <Tooltip title="Cancel">
                            <span>
                                <IconButton size="small" onClick={handleCancelEditJiraTicket}>
                                    <Cancel fontSize="small" />
                                </IconButton>
                            </span>
                        </Tooltip>
                    </Box>
                );
            }

            if (!jiraId) {
                return <></>;
            }

            const jiraUrl = generateJiraBaseLink(name, jiraId);
            return (
                <Box display="flex" alignItems="center" gap="4px">
                    {jiraUrl ? (
                        <a rel="noopener noreferrer" href={jiraUrl} target="_blank">
                            {jiraId}
                        </a>
                    ) : (
                        <span>{jiraId}</span>
                    )}
                    <Tooltip title={isEditable ? 'Edit JIRA ID' : 'Editing disabled'}>
                        <span>
                            <PermissionButton
                                iconOnly
                                permission={HOME_PERMISSIONS.JIRA_ID}
                                size="small"
                                aria-label="edit JIRA ID"
                                onClick={() => handleEditJiraTicket(params.row)}
                            >
                                <Edit fontSize="small" />
                            </PermissionButton>
                        </span>
                    </Tooltip>
                </Box>
            );
        }
    }, {
        name: "Create/ Recreate Ticket",
        mapping: "actions",
        align: 'center',
        renderCell: (params) => {
            const is_request_automated = params.row["is_request_automated"];
            const create_ticket_status = params.row["create_ticket_status"];
            const response_is_open = params.row["response_is_open"];
            const integration_pattern = params.row["integration_pattern"];

            if (is_request_automated === 'No' && !create_ticket_status) {
                return (<PermissionButton
                    permission={HOME_PERMISSIONS.CREATE_RECREATE}
                    variant="contained"
                    color="primary"
                    className={'actionButton'}
                    onClick={() => {
                        handleCreate(params.row);
                    }}
                >
                    Create
                </PermissionButton>)
            }
            if (response_is_open === true
                && integration_pattern === "API Push"
                && is_request_automated === "Yes") {
                return (<PermissionButton
                    permission={HOME_PERMISSIONS.CREATE_RECREATE}
                    variant="contained"
                    color="primary"
                    className={'actionButton'}
                    onClick={() => {
                        handleReCreate(params.row);
                    }}
                >
                    Recreate
                </PermissionButton>)
            }

            return <></>

        }

    }, {
        name: "View Response",
        mapping: "viewResponse",
        align: 'center',
        // headerAlign: 'left',
        renderCell: (params) => {
            const display = params.row["display"];
            const app_id = params.row["id"];

            return (
                <Button
                    variant="contained"
                    size="small"
                    startIcon={<FindInPage />}
                    onClick={() => {
                        handleViewResponseDownstream({
                            tabname: `${display} Response`,
                            app_id: app_id
                        })
                    }}
                    sx={standardButtonStyle}
                >
                    View
                </Button>
            )
        }
    }];

    const handleClose = () => {
        setMessage(null);
    }
    return (
        <Box height={"calc( 100% - 130px )"}>
            {createStatusData && (
                <Dialog maxWidth={"sm"} open={true} className={classes.dialog}>
                    <DialogTitle onClose={handleCreateStatusDialogClose} >
                        Create Ticket
                    </DialogTitle>
                    <DialogContent dividers>
                        <Box minWidth={350}>
                            <Box display="flex" alignItems="center" marginBottom="16px">
                                <Box component={"span"} fontWeight={600} marginRight={"10px"} fontSize="0.85rem" color="#1e3a5f" minWidth="130px">
                                    Application Name :
                                </Box>
                                <span style={{ fontSize: '0.85rem', color: '#334155' }}>{createStatusData?.display}</span>
                            </Box>
                            <Box display={"flex"} alignItems={"center"}>
                                <Box marginRight={"10px"} fontWeight={600} fontSize="0.85rem" color="#1e3a5f" minWidth="130px">
                                    Ticket Id :
                                </Box>
                                <Box flex={1}>
                                    <TextField
                                        size={"small"}
                                        type={"text"}
                                        fullWidth
                                        label=""
                                        ref={ticketIdRefInput}
                                        variant="outlined"
                                        placeholder='Enter the Ticket ID'
                                    />
                                </Box>
                            </Box>
                            <Box className='isInvalidText'>
                                {createInvalidMsg}
                            </Box>
                        </Box>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleCreateStatusDialogClose} >
                            Cancel
                        </Button>
                        <Button onClick={handleCreateStatusDialogSubmit}>
                            Submit
                        </Button>
                    </DialogActions>
                </Dialog>
            )}
            <Snackbar
                style={{
                    marginTop: "30px"
                }}
                open={!!message}
                onClose={handleClose}
                autoHideDuration={6000}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}

            >
                <Alert
                    onClose={handleClose}
                    severity={message?.severity}>
                    {message?.text}
                </Alert>
            </Snackbar>
            {isLoading && <LoadingIndicator />}
            <div className={classes.tableWrapper}>
                <table>
                    <thead>
                        <tr>
                            {columns.map((col) => {
                                const currentWidth = columnWidths[col.mapping] || col.width || (col.flex ? 200 : 150);
                                return (
                                    <th
                                        key={col.mapping}
                                        style={{
                                            width: currentWidth,
                                            minWidth: col.width || 100,
                                            textAlign: col.align || 'left'
                                        }}
                                    >
                                        {col.name}
                                        <div
                                            className="resize-handle"
                                            onMouseDown={(e) => {
                                                e.preventDefault();
                                                const startX = e.clientX;
                                                const startWidth = currentWidth;

                                                const handleMouseMove = (e) => {
                                                    const diff = e.clientX - startX;
                                                    const newWidth = Math.max(col.width || 100, startWidth + diff);
                                                    setColumnWidths(prev => ({
                                                        ...prev,
                                                        [col.mapping]: newWidth
                                                    }));
                                                };

                                                const handleMouseUp = () => {
                                                    document.removeEventListener('mousemove', handleMouseMove);
                                                    document.removeEventListener('mouseup', handleMouseUp);
                                                };

                                                document.addEventListener('mousemove', handleMouseMove);
                                                document.addEventListener('mouseup', handleMouseUp);
                                            }}
                                        />
                                    </th>
                                );
                            })}
                        </tr>
                    </thead>
                    <tbody>
                        {(data || []).map((row, index) => {
                            const isError = row.response_action === "error" || row.response_action === "unable_to_retrieve";
                            return (
                                <tr
                                    key={row.id || index}
                                    className={isError ? "isInactive-row-cust-cls" : ""}
                                >
                                    {columns.map((col) => {
                                        const currentWidth = columnWidths[col.mapping] || col.width || (col.flex ? 200 : 150);
                                        let cellContent = row[col.mapping];

                                        if (col.renderCell) {
                                            cellContent = col.renderCell({ row });
                                        }

                                        const tooltipText = col.displayTootip ? col.displayTootip.map(key => row[key]).join(', ') : cellContent;

                                        return (
                                            <td
                                                key={col.mapping}
                                                title={typeof tooltipText === 'string' ? tooltipText : ''}
                                                style={{
                                                    width: currentWidth,
                                                    textAlign: col.align || 'left'
                                                }}
                                            >
                                                {cellContent}
                                            </td>
                                        );
                                    })}
                                </tr>
                            )
                        })}
                        {(!data || data.length === 0) && (
                            <tr>
                                <td colSpan={columns.length} style={{ textAlign: 'center', padding: '20px', color: '#64748b' }}>
                                    No data available
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
            {displayDialog && (
                <Box>
                    <CustomDialog
                        isOpen={!!displayDialog}
                        isLoading={!hubStatusData}
                        updateDialogStatus={() => {
                            setDisplayDialog(null)
                        }}
                        popupGridData={hubStatusData?.map((_displayHubStatusPopup, index) => {
                            // Formating the response to add the ID which is required for the grid for displaying row index
                            return {
                                id: index + 1,
                                ..._displayHubStatusPopup
                            }
                        }) || []}
                        popupColumns={[{
                            name: "#",
                            mapping: "id",
                        }, {
                            name: 'TC System Name',
                            mapping: 'product'
                        }, {
                            name: 'Response Status',
                            mapping: 'status'
                        }]}
                        enablePagination={false}
                        title={(
                            <>
                                <span>RequestId</span> : {requestDetails?.dsar_id}
                            </>
                        )}
                    />
                </Box>
            )}
        </Box>
    )
}

export default React.memo(List);